<!--  过车管理  -->
<template>
  <div class="passing-container">
    <side-drawer :visible.sync="leftVisible" :drawer-style="{ width: '475px' }" :zoom="zoom">
      <!--  车次列表  -->
      <passing-search-list ref="trainSearchList" :permi-str="permiStr" :is-h-g-z="isHGZ" @handleAdd="handleAdd"
        @handle-select="handleTrainSelect"></passing-search-list>
    </side-drawer>
    <!--  动画  -->
    <img-player v-if="carriageList.length" ref="imgPlayer" :zoom="zoom" :permi-str="permiStr" :initial-idx="initialIdx"
      :carriage-idx="carriageIdx" :loading.sync="playerLoading" :direction="slideDirection" :slide-list="carriageList"
      :train-id="trainSelectedInfo.id" :report-visible.sync="reportVisible" @addCarriage="handleAdd(true)"
      @update-idx="handleCarriageSelect" @refreshEarlyWarning="refreshEarlyWarning"
      @closeSideDrawer="closeSideDrawer"></img-player>
    <side-drawer :visible.sync="rightVisible" is-right :drawer-style="{ width: '455px' }">
      <!--  异常信息统计  -->
      <!--      <error-statistics ref="errStatistics"></error-statistics>-->
      <!--  车厢列表  -->
      <passing-train-list ref="passingTrainList" :permi-str="permiStr" :loading.sync="carriageLoading"
        :data.sync="carriageList" :base-data="baseCarriageList" :carriage-idx="carriageIdx" @handleAdd="handleAdd(true)"
        @handleDel="handleSearchList(trainSelectedInfo.id)" @handle-select="handleCarriageSelect($event, true)">
      </passing-train-list>
      <div v-if="carriageInfo && rightVisible" :key="carriageInfo.id">
        <!--  车厢详情  -->
        <carriage-form :carriage-info="carriageInfo" @updateCarriage="updateCarriage"></carriage-form>
        <!--  车厢异常信息  -->
        <error-list ref="errorList" :permi-str="permiStr" :carriage-info="carriageInfo"
          @handleDel="handleSearchList(trainSelectedInfo.id)"
          @after-handle="handleSearchList(trainSelectedInfo.id)"></error-list>
      </div>
    </side-drawer>
    <!--  录入  -->
    <dialog-reset top="10vh" height="500px" width="60%" zoomShow ask_Dialogdrag title="人工录入" :visible.sync="addVisible">
      <train-add ref="trainAdd" :visible.sync="addVisible" :is-h-g-z="isHGZ" :carriage-list="carriageList"
        :total-carriage="carriageList.length" @afterSubmit="handleSearchList"></train-add>
    </dialog-reset>
    <!--  检车报告  -->
    <train-line-report v-if="reportVisible" :visible.sync="reportVisible" :trainInfo="trainSelectedInfo"
      :add-index="addindex" :direction="slideDirection" @updateCarriage="updateCarriage"
      @reportConfirm="onReportConfirm" :is-h-g-z="isHGZ"></train-line-report>
  </div>
</template>

<script>
import SideDrawer from "./components/side-drawer.vue";
import PassingSearchList from "./modules/passing-search-list.vue";
import PassingTrainList from "./modules/passing-train-list.vue";
import ImgPlayer from "./modules/img-player.vue";
import ErrorStatistics from "./modules/error-statistics.vue";
import CarriageForm from "./modules/carriage-form.vue";
import ErrorList from "./modules/error-list.vue";
import {
  getAddindex,
  getCarriageList,
} from "@/api/handover-inspection/passing-manage";
import TrainAdd from "./modules/train-add.vue";
import DialogReset from "@/basic-common/components/DialogReset.vue";
import TrainLineReport from "./modules/train-line-report.vue";
import { getSysConfig } from "@/util/util";

export default {
  name: "passing-manage",
  components: {
    TrainLineReport,
    DialogReset,
    TrainAdd,
    ErrorList,
    CarriageForm,
    ErrorStatistics,
    ImgPlayer,
    PassingTrainList,
    PassingSearchList,
    SideDrawer,
  },
  data() {
    // 化工站
    const isHGZ = window.location.pathname.includes('passing-manage-hgz')
    return {
      isHGZ,
      permiStr: isHGZ ? 'passing-manage-hgz' : 'passing-manage',
      leftVisible: true,
      rightVisible: false,
      trainSelectedInfo: null, // 选中车次信息
      carriageLoading: false,
      carriageList: [], // 车厢数据
      baseCarriageList: [], // 记录初始车厢数据
      carriageIdx: 0, // 选中车厢下标
      slideDirection: "left", // 方向
      playerLoading: false, // 动画loading (等待动画加载后可切换车厢)
      addVisible: false, // 手动录入 visible
      reportVisible: false, // 检车报告 visible
      addindex: 0, // 不知道是啥
      initialIdx: 0, // 动画初始车厢下标
      zoom: 1.1,
    };
  },
  methods: {
    // 车次选择
    async handleTrainSelect(row, type = false) {

      const { id: trainListId, checkFlag, direction } = row;
      this.trainSelectedInfo = this.deepClone(row);
      // 查询异常汇总
      // this.$refs.errStatistics.statistics({ trainListId });
      // 定义动画方向
      this.slideDirection = Number(direction) === 4 ? "left" : "right";
      // 绿色(已预检)自动打开检车报告
      // if (checkFlag) this.reportVisible = true
      this.resetCarriageInfo();
      this.carriageLoading = true;
      // 获取 addindex
      const idxRes = await getAddindex({ id: trainListId });
      this.addindex = idxRes.data || 0;
      this.$refs.passingTrainList.handleReset()
      this.searchCarriageList(trainListId);

      if (type) {
        this.reportVisible = true
      }
    },
    /**
     * 查询车厢列表
     * @param trainListId 车次 id
     * @param initialIdx 动画初始车厢下标
     */
    searchCarriageList(trainListId, initialIdx = 0) {
      this.initialIdx = initialIdx
      getCarriageList({ trainListId })
        .then((res) => {
          // 处理车厢图片及异常信息
          const arr = res.data.map((item, idx) => {
            // 本车厢异常信息
            const problemList = item.problemList || [];
            // 记录车厢三侧异常信息
            const errorInfo = {}
            problemList.forEach(item => {
              const { camera } = item
              errorInfo[camera] = this.deepClone(item)
            })
            return {
              ...item,
              isError: problemList.some(item => item.hasProblem), // isError 用于标记此车厢是否有异常（problemList 中有一个 hasProblem 为 true 就是 true）
              leftPath: this.getImgUrl(item.carriageIndex, "L", errorInfo['A']),
              topPath: this.getImgUrl(item.carriageIndex, "M", errorInfo['B']),
              rightPath: this.getImgUrl(item.carriageIndex, "R", errorInfo['C']),
            };
          });
          this.carriageList = this.deepClone(arr);
          this.baseCarriageList = this.deepClone(arr);
        })
        .finally(() => {
          this.carriageLoading = false;
        });
    },
    /**
     * 切换车厢
     * @param idx 车厢下标
     * @param slideTo 是否需要切换图像
     */
    handleCarriageSelect(idx, slideTo) {
      // 动画加载时禁止切换车厢
      if (this.playerLoading) return;
      this.carriageIdx = idx;
      if (this.$refs.imgPlayer && slideTo) this.$refs.imgPlayer.slideTo(idx);
    },
    resetCarriageInfo() {
      this.carriageIdx = 0;
      this.carriageList = [];
      this.baseCarriageList = [];
    },
    // 重新查询列表
    handleSearchList(trainListId, initialIdx) {
      // 查询车次
      this.$refs.trainSearchList.handleRefresh();
      // 查询车厢
      if (trainListId) {
        this.resetCarriageInfo();
        this.searchCarriageList(trainListId, initialIdx);
      }
    },
    // 点击录入 carriage: 录入车厢
    handleAdd(carriage) {
      let params = null;
      // 新增车厢
      if (carriage) {
        if (!this.trainSelectedInfo) {
          this.$message.error("请先选择车次");
          return;
        }
        params = this.deepClone(this.trainSelectedInfo);
      }
      this.addVisible = true;
      this.$nextTick(() => {
        this.$refs.trainAdd.initForm(params);
      });
    },
    // 车节详情单字段修改回调
    updateCarriage(info) {
      // 获取当前修改车厢下标
      const index = this.carriageList.findIndex((item) => item.id === info.id); // 展示列表下标
      const baseIndex = this.baseCarriageList.findIndex(
        (item) => item.id === info.id
      ); // 初始车厢数据下标
      // 更新列表展示数据
      this.$set(
        this.carriageList,
        index,
        this.deepClone({ ...this.carriageList[index], ...info })
      );
      // 更新 baseData 对应数据
      this.$set(
        this.baseCarriageList,
        baseIndex,
        this.deepClone({ ...this.baseCarriageList[baseIndex], ...info })
      );
      this.carriageIdx = baseIndex
      this.$forceUpdate()
    },
    // 检车报告提交
    onReportConfirm() {
      this.reportVisible = false
      this.$refs.trainSearchList.handleRefresh()
    },
    /**
     * 获取图片路径
     * @param carriageIndex 车厢下标
     * @param position 图片位置
     * @param errorInfo 图片异常信息  q
     */
    getImgUrl(carriageIndex, position, errorInfo) {
      const baseUrl = getSysConfig('CHECK_MINIO')
      const { id, poundno } = this.trainSelectedInfo;
      // hasProblem 为 true 时图片标记为异常
      const result = { id: position + carriageIndex, isError: errorInfo.hasProblem };
      const no = carriageIndex.toString().padStart(3, "0");
      // 有 errorInfo 就取异常图片，不管是否处理完毕
      // result.src = `${baseUrl}/train${errorInfo ? "/bak" : ""}/${poundno}/ZB_RE_ORIGIN_SHOW/${id}/ZB${id}${position}_${no}.jpg?t=${Math.random()}`;
      if (errorInfo) {
        // ?t=${Math.random()}
        result.src = `${baseUrl}/train/bak/${poundno}/ZB_RE_ORIGIN_SHOW/${id}/ZB${id}${position}_${no}.jpg`;
      } else {
        result.src = `${baseUrl}/train/${poundno}/ZB_RE_ORIGIN_SHOW/${id}/ZB${id}${position}_${no}.jpg`;
      }
      // 原图
      result.original = `${baseUrl}/train/${poundno}/ZB_RE_ORIGIN_SHOW/${id}/ZB${id}${position}_${no}.jpg`;
      return result;
    },
    //刷新预警车辆
    refreshEarlyWarning(idx) {
      this.handleSearchList(this.trainSelectedInfo.id, idx);
    },
    closeSideDrawer() {
      this.leftVisible = false
      this.rightVisible = false
    }
  },
  computed: {
    // 当前选中车厢信息
    carriageInfo() {
      if (!this.carriageList || !this.carriageList.length) return null;
      return this.carriageList[this.carriageIdx];
    },
  },
};
</script>

<style scoped lang="scss">
@import "./style/index.scss";
</style>
<style>
body {
  overflow: hidden;
}
</style>
